import React, { useState, createContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { USER_QUERY } from '../components/accounts/mutations';

const defaultValues = {
    user: {},
};

export const FirebaseContext = createContext(defaultValues);

export const FirebaseProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const isBrowser = typeof window != 'undefined';
    let token = null;
    if (isBrowser && localStorage.getItem('cid')) {
        token = JSON.parse(localStorage.getItem('cid')).token;
    }

    const { loading, error, data } = useQuery(USER_QUERY, {
        variables: { customerAccessToken: token },
    });

    if (error) {
        console.log(error);
        localStorage.removeItem('cid');
    }

    useEffect(() => {
        if (!loading && token != null) {
            let customerFound = data && data.customer;

            if (isBrowser && localStorage.getItem('cid')) {
                token = JSON.parse(localStorage.getItem('cid')).token;
            }

            console.log('customerFound', customerFound, data);
            setUser(customerFound);
        }
    }, [loading, data]);
    return (
        <FirebaseContext.Provider
            value={{
                ...defaultValues,
                user,
            }}
        >
            {children}
        </FirebaseContext.Provider>
    );
};

export default FirebaseProvider;
